import { render, staticRenderFns } from "./NlpWhySatoshiIcon4.vue?vue&type=template&id=05920661"
import script from "./NlpWhySatoshiIcon4.vue?vue&type=script&lang=js"
export * from "./NlpWhySatoshiIcon4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports